<template>
  <div class="logon">
    <div class="wrapper fadeInDown">
      <div id="formContent">
        <div class="fadeIn first">
          <img src="@/assets/logo.png" id="icon" />
        </div>
        <form>
          <h3>Reset de Senha</h3>

          <!-- Etapa 1: Iniciar reset -->
          <template v-if="!step2">
            <input type="text" id="login" class="fadeIn second" name="login" placeholder="CPF/CNPJ" :value="login"
              @input="login = applyCpfCnpjMask($event.target.value)" @keypress.enter="initiatePasswordReset">
            <input type="button" class="fadeIn fourth" value="Iniciar Reset" @click="initiatePasswordReset"
              :disabled="loading || !login">
          </template>

          <!-- Etapa 2: Confirmar reset com MFA -->
          <template v-else>
            <input type="text" id="mfaCode" class="fadeIn second" name="mfaCode" placeholder="Código MFA"
              v-model="mfaCode" v-mask="'######'" maxlength="6" @keypress.enter="confirmPasswordReset">
            <input type="password" id="newPassword" class="fadeIn third" name="newPassword" placeholder="Nova Senha"
              v-model="newPassword" minlength="6" @keypress.enter="confirmPasswordReset">
            <div class="text-right mt-2 mb-3 mr-5 fadeIn fourth">
              <a href="#" @click.prevent="step2 = false; mfaCode = ''; newPassword = ''; mfaTransactionId = null"
                style="color: #999;">Voltar</a>
            </div>
            <input type="button" class="fadeIn fourth" value="Confirmar" @click="confirmPasswordReset"
              :disabled="loading || !mfaCode || !newPassword || newPassword.length < 6">
          </template>

          <div class="text-center fadeIn fourth mb-3">
            <router-link to="/login">Voltar ao login</router-link>
          </div>
        </form>
      </div>
    </div>

  </div>
</template>

<script>
import { normalizeCpfCnpj, applyCpfCnpjMask } from '@/util/cnpj'

export default {
  name: 'logon',
  data() {
    return {
      login: '',
      step2: false,
      mfaTransactionId: null,
      mfaCode: '',
      newPassword: '',
      loading: false
    }
  },
  mounted() {
    this.setFocus('login');
  },
  methods: {
    applyCpfCnpjMask,
    initiatePasswordReset() {
      const loginClean = normalizeCpfCnpj(this.login);
      if (!loginClean || loginClean.length < 11) {
        this.$notify({ type: 'warning', message: 'Informe um CPF/CNPJ válido' });
        return;
      }

      this.loading = true;

      this.$clubApi.post('/user/backoffice/password/reset/initiate', {
        login: loginClean
      })
        .then((response) => {
          const result = response.data.object;
          if (!result) {
            this.$notify({ type: 'warning', message: 'Erro ao iniciar reset de senha' });
            return;
          }

          if (result.mode === 'EMAIL') {
            const hint = result.emailHint ? ` (${result.emailHint})` : '';
            this.$notify({
              type: 'success',
              message: `Senha temporária enviada por e-mail${hint}. Use-a para fazer login.`
            });
            setTimeout(() => this.$router.push('/login'), 2500);
            return;
          }

          if (result.mode === 'MFA' && result.mfaTransactionId) {
            this.mfaTransactionId = result.mfaTransactionId;
            this.step2 = true;
            this.setFocus('mfaCode');
            this.$notify({
              type: 'success',
              message: 'Código MFA enviado por SMS para o telefone cadastrado!'
            });
            return;
          }

          this.$notify({ type: 'warning', message: 'Erro ao iniciar reset de senha' });
        })
        .catch((error) => this.$notify({ type: 'warning', message: error.response.data.msg || 'Erro ao iniciar reset de senha' }))
        .finally(() => {
          this.loading = false;
          NProgress.done();
        });
    },
    confirmPasswordReset() {
      if (!this.mfaCode || this.mfaCode.length !== 6) {
        this.$notify({ type: 'warning', message: 'Informe o código MFA de 6 dígitos' });
        return;
      }

      if (!this.newPassword || this.newPassword.length < 6) {
        this.$notify({ type: 'warning', message: 'A senha deve ter no mínimo 6 caracteres' });
        return;
      }

      if (!this.mfaTransactionId) {
        this.$notify({ type: 'warning', message: 'Erro: Transação MFA não encontrada. Inicie o processo novamente.' });
        return;
      }

      this.loading = true;
      const loginClean = normalizeCpfCnpj(this.login);

      this.$clubApi.post('/user/backoffice/password/reset', {
        login: loginClean,
        newPassword: this.newPassword,
        mfaTransactionId: this.mfaTransactionId,
        mfaCode: this.mfaCode
      })
        .then((response) => {
          if (response.data) {
            this.$notify({
              type: 'success',
              message: 'Senha alterada com sucesso! Você pode fazer login agora.'
            });
            setTimeout(() => this.$router.push('/login'), 2000);
          } else {
            this.$notify({ type: 'warning', message: 'Erro ao confirmar reset de senha' });
          }
        })
        .catch((error) => this.$notify({ type: 'warning', message: error.response.data.msg || 'Erro ao confirmar reset de senha' }))
        .finally(() => {
          this.loading = false;
          NProgress.done();
        });

    },
    setFocus(elementId) {
      this.$nextTick(() => {
        const el = document.getElementById(elementId);
        if (el) el.focus();
      });
    }
  }
}
</script>

<style scoped>
/* BASIC */

html {
  background-color: #2C4759;
}

body {
  font-family: "Poppins", sans-serif;
  height: 100vh;
}

a {
  color: #999;
  display: inline-block;
  text-decoration: none;
  font-weight: 400;
}

h2 {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  display: inline-block;
  margin: 40px 8px 10px 8px;
  color: #cccccc;
}

.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 20px;
  margin-top: 100px;
}

#formContent {
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 30px;
  width: 90%;
  max-width: 450px;
  position: relative;
  padding: 0px;
  -webkit-box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  text-align: center;
}

#formFooter {
  background-color: #f6f6f6;
  border-top: 1px solid #dce8f1;
  padding: 25px;
  text-align: center;
  -webkit-border-radius: 0 0 10px 10px;
  border-radius: 0 0 10px 10px;
}

/* TABS */

h2.inactive {
  color: #cccccc;
}

h2.active {
  color: #0d0d0d;
  border-bottom: 2px solid #2C4759;
}

/* FORM TYPOGRAPHY*/

input[type=button],
input[type=submit],
input[type=reset] {
  background-color: #2C4759;
  border: none;
  color: white;
  padding: 15px 80px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  text-transform: uppercase;
  font-size: 13px;
  -webkit-box-shadow: 0 10px 30px 0 rgba(106, 233, 169, 0.4);
  box-shadow: 0 10px 30px 0 rgba(130, 214, 189, 0.4);
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
  margin: 5px 20px 40px 20px;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

input[type=button]:hover,
input[type=submit]:hover,
input[type=reset]:hover {
  background-color: #88BCC6;
}

input[type=button]:active,
input[type=submit]:active,
input[type=reset]:active {
  -moz-transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -o-transform: scale(0.95);
  -ms-transform: scale(0.95);
  transform: scale(0.95);
}

input[type=text] {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
}

input[type=password] {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
}

input[type=text]:focus {
  background-color: #fff;
  border-bottom: 2px solid #2C4759;
}

input[type=text]:focus {
  background-color: #fff;
  border-bottom: 2px solid #2C4759;
}

input[type=password]:focus {
  background-color: #fff;
  border-bottom: 2px solid #2C4759;
}

input[type=text]:placeholder {
  color: #cccccc;
}

h3 {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  margin: 20px 8px 10px 8px;
  color: #0d0d0d;
}

/* Simple CSS3 Fade-in-down Animation */
.fadeInDown {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }

  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }

  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

/* Simple CSS3 Fade-in Animation */
@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@-moz-keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.fadeIn {
  opacity: 0;
  -webkit-animation: fadeIn ease-in 1;
  -moz-animation: fadeIn ease-in 1;
  animation: fadeIn ease-in 1;

  -webkit-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
  animation-fill-mode: forwards;

  -webkit-animation-duration: 1s;
  -moz-animation-duration: 1s;
  animation-duration: 1s;
}

.fadeIn.first {
  -webkit-animation-delay: 0.4s;
  -moz-animation-delay: 0.4s;
  animation-delay: 0.4s;
}

.fadeIn.second {
  -webkit-animation-delay: 0.6s;
  -moz-animation-delay: 0.6s;
  animation-delay: 0.6s;
}

.fadeIn.third {
  -webkit-animation-delay: 0.8s;
  -moz-animation-delay: 0.8s;
  animation-delay: 0.8s;
}

.fadeIn.fourth {
  -webkit-animation-delay: 1s;
  -moz-animation-delay: 1s;
  animation-delay: 1s;
}

/* Simple CSS3 Fade-in Animation */
.underlineHover:after {
  display: block;
  left: 0;
  bottom: -10px;
  width: 0;
  height: 2px;
  background-color: #56baed;
  content: "";
  transition: width 0.2s;
}

.underlineHover:hover {
  color: #0d0d0d;
}

.underlineHover:hover:after {
  width: 100%;
}

/* OTHERS */

*:focus {
  outline: none;
}

#icon {
  width: 60%;
  margin-bottom: 20px;
  margin-top: 20px;
}

input[type=button]:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
